:host {
  display: block;
  width: 100%;
  margin: var(--cms-components-mb);
  @include cms-base-font-100;
  @include cms-margin-center;
}

.work-step-container {
  --cms-grid-padding: var(--cms-spacing-100);
  @include cms-default-grid-container;
}

.work-step-container>* {
  grid-area: var(--cms-default-grid-area);
}

.headline-wrapper {
  --cms-grid-padding: 0;
  margin-top: 0;
  margin-bottom: var(--cms-spacing-075);
  @include headline-font-150;
}

.step-count {
  padding-right: var(--cms-spacing-050);
  @include headline-font-150;
}

.text-content-wrapper {
  margin-bottom: var(--cms-spacing-075);
}

.text-container {
  color: var(--cms-theme-text-color);
}

.step-text {
  display: inline;
}

.step-text p:nth-child(1) {
  display: inline;
  margin: 0;
}

.step-text p {
  margin-top: var(--cms-spacing-075);
  margin-bottom: 0;
}

.work-step-image {
  border: var(--cms-border-size-xs) solid var(--cms-theme-border-color);
}

.step-text a {
  color: var(--cms-theme-text-color);
  text-decoration: underline;
}

.modal-icon {
  display: none;
  position: absolute;
  right: var(--cms-spacing-150);
  top: var(--cms-spacing-100);
}

@include media-width($breakpoint-sm) {

  .work-step-container.left,
  .work-step-container.right {
    grid-auto-flow: column;
  }

  .text-container.only-content,
  .image-wrapper.only-content {
    --cms-default-grid-area: auto / auto / auto / span 12;
  }

  .image-wrapper {
    --cms-default-grid-area: auto / auto / auto / span 4;
  }

  .text-container {
    --cms-default-grid-area: auto / 3 / auto / span 4;
  }

  .work-step-container.left .image-wrapper {
    --cms-default-grid-area: auto / 3 / auto / span 4;
  }

  .work-step-container.left .text-container {
    --cms-default-grid-area: auto / auto / auto / span 4;
  }

  .modal-icon {
    display: block;
  }

  .image-wrapper {
    cursor: pointer;
  }

  .text-content-wrapper {
    margin-bottom: 0;
  }
}

@include media-width($breakpoint-md) {

  .text-container.only-content,
  .image-wrapper.only-content {
    --cms-default-grid-area: auto / 3 / auto / span 8;
  }

}